import styled, { css } from 'react-emotion';
import Button from '../Button/Button';
const commonStyles = css `
  font-size: 1rem;
  border: 1px solid transparent;
  padding: 1rem;
  /* Button is a child of a flex container, so this aligns to bottom */
  margin-top: auto;
  width: 100%;
`;
export const CommitButton = styled(Button) `
  background: #2f80ed;
  ${commonStyles};
`;
export const CancelButton = styled(Button) `
  background: white;
  color: #000;
  ${commonStyles};
`;
//# sourceMappingURL=ChannelSelectorButtons.js.map